<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card max-width="75%" width="500" flat>
        <v-row class="d-flex">
          <h1 class="mb-4">Selecciona una fecha</h1>
        </v-row>
        <v-row justify="center">
          <v-date-picker
            full-width
            show-current="false"
            color="secondary"
            year-icon="mdi-calendar-blank"
            v-model="selectedDate"
            locale="es"
            :min="today"
            @change="uploadHorarios(selectedDate)"
          ></v-date-picker>
        </v-row>

        <v-row class="d-flex">
          <h1 class="mb-4">Selecciona una hora</h1>
        </v-row>
        <v-row class="d-flex align-center justify-center" v-if="horas.length">
          <v-tooltip top v-for="(i, index) in horas" :key="index">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="d-flex ma-2"
                :color="i.selected"
                @click="selectHour(i)"
                v-bind="attrs"
                v-on="i.recommended ? on : null"
              >
                <v-badge
                  :color="i.recommended ? 'secondary' : null"
                  :icon="i.recommended ? 'mdi-fire' : null"
                  >{{ i.hora + " hrs" }}</v-badge
                >
              </v-btn>
            </template>
            <span>Popular</span>
          </v-tooltip>
        </v-row>
        <v-row class="d-flex align-center justify-center" v-if="!horas.length">
          <h2>Prueba otro día</h2>
          <p>Nuestro horario de atención es de 8:00 hrs a 16:00 hrs.</p>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="secondary" text block @click="back()">Atrás</v-btn>
          </v-col>
          <v-col>
            <v-btn
              class="buttonPrimary"
              block
              :disabled="!horas.length"
              @click="next()"
              >Siguiente</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  computed: {
    ...mapFields(["landingCounter", "formOkBoy"]),
  },
  data() {
    return {
      selectedDate: this.getFormattedDate(),
      today: this.getFormattedDate(),
      selectedHour: "",
      horasToday: [],
      horasFull: [],
      horasWeekend: [],
      horas: [],
    };
  },
  methods: {
    getFormattedDate() {
      const date = new Date()
        .toLocaleString('es-MX', {timeZone: 'America/Mexico_City'})
        .replaceAll(',', '')
        .split(' ')[0]
        .split('/')

      return `${date[2]}-${date[1].toString().length > 1 ? date[1] : '0' + date[1]}-${date[0].toString().length > 1 ? date[0] : '0' + date[0]}`
    },
    selectHour(index) {
      for (let i = 0; i < this.horas.length; i++) {
        this.horas[i].selected = "white";
      }
      this.selectedHour = index.hora;
      index.selected = "primary";
    },
    next() {
      this.landingCounter++;
      this.formOkBoy.fechaServicio = this.selectedDate;
      this.formOkBoy.horaServicio = this.selectedHour;
      this.formOkBoy.dateServices =
      this.selectedDate + "T" + this.selectedHour + ":00.005Z";
      mixpanel.track('Seleccionó Fecha y Hora del Servicio', {Fecha:this.formOkBoy.fechaServicio, Hora:this.selectedHour + ":00.005Z"});
    },
    back() {
      this.landingCounter--;
    },
    uploadHorarios(selectedDate) {
      this.getSchedules(selectedDate)
    },
    selectedDay(selectedDate){
      if (this.today === selectedDate) {
        this.horas = this.horasToday;
        this.selectPopular(this.horasToday);
      } else if (
        new Date(selectedDate).getDay() === 5 ||
        new Date(selectedDate).getDay() === 6
      ) {
        this.horas = this.horasWeekend;
        this.selectPopular(this.horasWeekend);
      } else {
        this.horas = this.horasFull;
        this.selectPopular(this.horasFull);
      }
    },
    selectPopular(horas) {
      for (let i = 0; i < horas.length; i++) {
        if (horas[i].recommended) {
          this.selectedHour = horas[i].hora;
          this.horas[i].selected = "primary";
        }
      }
    },
    getSchedules(selectedDate = null) {
      const { address:{ latitude, longitude } } = this.formOkBoy
      Axios.get(config.apiBaseUrl + `/schedules/available?latitude=${latitude}&longitude=${longitude}`, {
        headers: {
          "x-api-key": config.apiKey,
        },
      })
        .then((response) => {
          this.horasToday = this.returnHoras(response.data.today);
          this.horasFull = this.returnHoras(response.data.full);
          this.horasWeekend = this.returnHoras(response.data.weekend);
          this.horas = this.horasToday;
          if(selectedDate !== null){
            this.selectedDay(selectedDate)
          }else{
            this.selectPopular(this.horasToday);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    returnHoras(horas) {
      let horasReturn = [];
      for (let i = 0; i < horas.length; i++) {
        horasReturn.push({
          hora: horas[i].value.slice(0, 5),
          selected: "white",
          recommended: horas[i].recommended,
        });
      }
      return horasReturn;
    },
  },
  mounted() {
    this.getSchedules();
  },
};


window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': 'https://okboy.app/schedule',
    'pageTitle': 'Date and time of the Service'
  });

</script>

<style scoped>
.theme--light.v-sheet {
  background-color: #f1f3f6;
  border-color: #f1f3f6;
  color: rgba(0, 0, 0, 0.87);
}
</style>